export default {
  "create-custom-event-success": {
    EN: "Successfully created custom event",
  },
  "create-custom-event-failure": {
    EN: "Failed to  create custom event",
  },
  "update-custom-event-success": {
    EN: "Successfully updated custom event",
  },
  "update-custom-event-failure": {
    EN: "Failed to  update custom event",
  },
  "schedule-custom-event-block-success": {
    EN: "Successfully scheduled custom event block",
  },
  "schedule-custom-event-block-failure": {
    EN: "Failed to schedule custom event block",
  },
};
